<div class="form-check">
  <input class="form-check-input" type="checkbox" (change)="checkValue($event)" id="acceptPrivacyCheckbox" required>
  <span class="form-check-label" for="acceptPrivacyCheckbox" ngPreserveWhitespaces>
    <span i18n="@@CheckAcceptPrivacyPrefixLabel">By submitting I accept the</span>
    <a [routerLink]="routerlink" [queryParams]="queryParams" target="_blank" i18n="@@CheckAcceptPrivacyLinkLabel">privacy policy</a><span i18n="@@CheckAcceptPrivacySuffixLabel">. *</span>
  </span>
</div>